import React from 'react';
import { Heart, Gift, Smartphone, QrCode } from 'lucide-react';

function HomePage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#F5F0E8',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif"
    }}>
      {/* Header */}
      <header style={{
        background: '#FAF7F2',
        borderBottom: '1px solid #E8DCC8',
        padding: '20px 24px',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        boxShadow: '0 1px 3px rgba(139, 115, 85, 0.08)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <div
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  }}
>
  <img
    src="/logo.svg" // replace with your logo filename
    alt="Logo"
    style={{
      width: '48px',
      height: '48px',
      objectFit: 'contain',
    }}
  />
  <h1
    style={{
      fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
      color: '#5D4E37',
      margin: 0,
      fontWeight: '600',
      letterSpacing: '-0.02em',
    }}
  >
    Heavenly Hangouts
  </h1>
</div>

          <button
            onClick={() => window.open('https://heavenlyhangoutsstore.com', '_blank')}
            style={{
              background: '#8B7355',
              color: '#FAF7F2',
              border: 'none',
              padding: '10px 24px',
              fontSize: '0.9rem',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '500',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#6B5D4F';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = '#8B7355';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <Gift style={{ width: '16px', height: '16px' }} />
            Shop
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: 'clamp(60px, 10vw, 120px) 24px clamp(40px, 8vw, 80px)'
      }}>
        <div style={{
          textAlign: 'center',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            color: '#5D4E37',
            margin: '0 0 24px',
            fontWeight: '600',
            letterSpacing: '-0.03em',
            lineHeight: '1.1'
          }}>
            Memories in Augmented Reality
          </h2>
          <p style={{
            fontSize: 'clamp(1.1rem, 2.5vw, 1.25rem)',
            color: '#7A6B5D',
            lineHeight: '1.6',
            margin: '0 0 48px',
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            Transform your special moments into immersive AR experiences with our premium memory frames.
          </p>
        </div>

        {/* Feature Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 'clamp(20px, 3vw, 32px)',
          marginBottom: 'clamp(60px, 8vw, 80px)'
        }}>
          {/* Card 1 - Scan QR */}
          <div style={{
            background: '#FAF7F2',
            borderRadius: '16px',
            padding: 'clamp(32px, 5vw, 40px)',
            border: '1px solid #E8DCC8',
            transition: 'all 0.3s ease',
            cursor: 'default'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 12px 24px rgba(139, 115, 85, 0.15)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: '#F0E9DD',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '20px'
            }}>
              <QrCode style={{ width: '24px', height: '24px', color: '#8B7355' }} />
            </div>
            <h3 style={{
              fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
              color: '#5D4E37',
              margin: '0 0 12px',
              fontWeight: '600'
            }}>
              Scan QR Code
            </h3>
            <p style={{
              fontSize: 'clamp(0.95rem, 1.8vw, 1rem)',
              color: '#7A6B5D',
              lineHeight: '1.6',
              margin: 0
            }}>
              Use your phone's camera or QR scanner app to scan the code on your AR memory frame.
            </p>
          </div>

          {/* Card 2 - View AR */}
          <div style={{
            background: '#FAF7F2',
            borderRadius: '16px',
            padding: 'clamp(32px, 5vw, 40px)',
            border: '1px solid #E8DCC8',
            transition: 'all 0.3s ease',
            cursor: 'default'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 12px 24px rgba(139, 115, 85, 0.15)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: '#F0E9DD',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '20px'
            }}>
              <Smartphone style={{ width: '24px', height: '24px', color: '#8B7355' }} />
            </div>
            <h3 style={{
              fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
              color: '#5D4E37',
              margin: '0 0 12px',
              fontWeight: '600'
            }}>
              Experience AR
            </h3>
            <p style={{
              fontSize: 'clamp(0.95rem, 1.8vw, 1rem)',
              color: '#7A6B5D',
              lineHeight: '1.6',
              margin: 0
            }}>
              Watch your memories come to life in stunning augmented reality through your phone.
            </p>
          </div>

          {/* Card 3 - Treasure Forever */}
          <div style={{
            background: '#FAF7F2',
            borderRadius: '16px',
            padding: 'clamp(32px, 5vw, 40px)',
            border: '1px solid #E8DCC8',
            transition: 'all 0.3s ease',
            cursor: 'default'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 12px 24px rgba(139, 115, 85, 0.15)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: '#F0E9DD',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '20px'
            }}>
              <Heart style={{ width: '24px', height: '24px', color: '#8B7355', fill: '#8B7355' }} />
            </div>
            <h3 style={{
              fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
              color: '#5D4E37',
              margin: '0 0 12px',
              fontWeight: '600'
            }}>
              Treasure Forever
            </h3>
            <p style={{
              fontSize: 'clamp(0.95rem, 1.8vw, 1rem)',
              color: '#7A6B5D',
              lineHeight: '1.6',
              margin: 0
            }}>
              Preserve your most precious moments in a beautiful frame that bridges physical and digital worlds.
            </p>
          </div>
        </div>

        {/* CTA Section */}
        <div style={{
          background: '#8B7355',
          borderRadius: '20px',
          padding: 'clamp(48px, 8vw, 80px) clamp(24px, 5vw, 48px)',
          textAlign: 'center',
          color: '#FAF7F2'
        }}>
          <h3 style={{
            fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
            margin: '0 0 20px',
            fontWeight: '600',
            letterSpacing: '-0.02em'
          }}>
            Ready to create your AR memory?
          </h3>
          <p style={{
            fontSize: 'clamp(1rem, 2vw, 1.1rem)',
            color: '#E8DCC8',
            lineHeight: '1.6',
            margin: '0 0 32px',
            maxWidth: '500px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            Browse our collection of premium frames and start preserving your memories in a whole new way.
          </p>
          <button
            onClick={() =>
  window.open(
    "https://wa.me/8547576814?text=Hi%20I%20want%20to%20know%20more%20about%20your%20Memory%20Frames.",
    "_blank"
  )
}

            style={{
              background: '#FAF7F2',
              color: '#5D4E37',
              border: 'none',
              padding: 'clamp(14px, 2.5vw, 16px) clamp(32px, 5vw, 48px)',
              fontSize: 'clamp(1rem, 2vw, 1.1rem)',
              borderRadius: '12px',
              cursor: 'pointer',
              fontWeight: '600',
              transition: 'all 0.2s ease',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <Gift style={{ width: '20px', height: '20px' }} />
            Shop Memory Frames
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        borderTop: '1px solid #E8DCC8',
        padding: '40px 24px',
        textAlign: 'center',
        color: '#A89788',
        fontSize: 'clamp(0.85rem, 1.5vw, 0.9rem)'
      }}>
        <p style={{ margin: 0 }}>
          © 2024 Heavenly Hangouts. Preserving memories, one frame at a time.
        </p>
      </footer>

      <style>{`
        * {
          box-sizing: border-box;
        }
        
        body {
          margin: 0;
          padding: 0;
        }
      `}</style>
    </div>
  );
}

export default HomePage;